import BaseModel from '../BaseModel';

export default class VacancyFaqCommon extends BaseModel {
  static entity = 'vacancyFaqCommon';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      question: this.string(null).nullable(),
      answer: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      fetch() {
        return this.get('vacancies/faq/common');
      },
    },
  }
}
